import enUS from "@/i18n/en-US.json";
import zhCN from "@/i18n/zh-CN.json";
import koKR from "@/i18n/ko-KR.json";
import jaJP from "@/i18n/ja-JP.json";
import plPL from "@/i18n/pl-PL.json";
import zhTW from "@/i18n/zh-TW.json";
import {
  getLocale,
  setLocale,
  StandardLocale,
  PlatformType,
  handleUrlLocale,
} from "@/gs-utils/core/storage/LocaleManager";

export const initI18n = () => {
  // locale的存储必须和主应用保持一致
  handleUrlLocale(PlatformType.ALL);
  let locale = StandardLocale.ZH_CN;
  setLocale(locale);
  window.micLocale = {};
  // 语言包放本地
  const micLocale: Record<string, any> = {
    [StandardLocale.EN_US]: enUS,
    [StandardLocale.KO_KR]: koKR,
    [StandardLocale.JA_JP]: jaJP,
    [StandardLocale.PL_PL]: plPL,
    [StandardLocale.ZH_TW]: zhTW,
    [StandardLocale.ZH_CN]: zhCN,
  };

  window.micLocale = micLocale[locale];
};

export const switchLocale = (locale: string) => {
  localStorage.setItem("locale", locale);
  if (window) {
    window.location.reload();
  }
};

export const i18n = (key: string, parameter?: any) => {
  try {
    const micLocale = window.micLocale;
    let value = micLocale[key];
    if (!value) {
      return key;
    }
    if (typeof parameter == "string" || typeof parameter == "number") {
      value = value.replace(/%s/g, parameter);
    } else if (typeof parameter == "object") {
      for (let k in parameter) {
        if (
          typeof parameter[k] == "string" ||
          typeof parameter[k] == "number"
        ) {
          value = value.replace(new RegExp(`{{${k}}}`, "g"), parameter[k]);
        }
      }
    }
    return value;
  } catch (err) {
    return key;
  }
};

initI18n();
